import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const THEMES = ["indigo", "green", "mono", "mono-dark"];
const STORAGE_KEY = "schoolos-theme";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem(STORAGE_KEY) || "indigo");

  useEffect(() => {
    const t = THEMES.includes(theme) ? theme : "indigo";
    document.documentElement.setAttribute("data-theme", t);
    localStorage.setItem(STORAGE_KEY, t);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
